<template>
  <div >
    <!--<div style="height: 4.5rem;">
    </div>-->
    <app-header v-if="header_show"></app-header>
    <div class="container">
      <ul style="border-radius: 0.3rem;margin-top: 1rem;">
        <li>
          <p>开户户名</p>
          <input type="text" ref="yh_hm" autocomplete="off" readonly="true" value=""/>
        </li>
        <li>
          <p>开户人身份证</p>
          <input type="text" ref="aac002" autocomplete="off" readonly="true"   placeholder="请填写您的身份证号" value=""/>
        </li>
        <li>
          <p>开户银行名称</p>
          <input type="text" ref="yh_mc" autocomplete="off"  readonly="true"   placeholder="请填写您的开户银行名称" />
        </li>
        <p style="color: red;font-size: 0.9rem;margin-left: 1.2rem;">银行名称格式:&nbsp;&nbsp;&nbsp;**行**省**市**区(路)**分理处(支行)</p>
        <li>
          <p>银行卡号/存折账号</p>
          <input type="number" ref="yh_kh" autocomplete="off" readonly="true"   placeholder="请填写银行卡号/存折账号"/>
        </li>
        <li>
          <p>座机电话</p>
          <input type="number" ref="aae005" autocomplete="off" readonly="true"   placeholder="请填写您的座机号码"/>
        </li>
        <p style="color: red;font-size: 0.9rem;margin-left: 1.2rem;">在职职工请填写您的办公电话</p>
      </ul>
      <p class="p_lin">身份证原件、银行卡/存折主页照片 &nbsp;
        <span style="color: #3485fa"></span>
      </p>
      <div class="sfzImgDiv" style="margin-top: 3%">
        <div class="b-left"></div>
        <div class="b-box-img" v-for="(item) in sfzImgList">
          <div class="img_back div_click" @click="showPopup('FDFP',item.url)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div>
        <div style="margin-top: 5%">
          <span class="p_lin" >电子/纸质发票 &nbsp;</span>
          <span style="color: #3485fa"></span>
        </div>
        <div style="margin-left: 5%;margin-top: 0.5rem">
          <!--<span class="linkBtn" @click="showPopup('ZZFP')">增值税发票样式</span>-->
          <span class="linkBtn" @click="showPopup('CZFP')">财政发票样式</span>
        </div>
      </div>
      <div class="dzfpImgDiv" style="margin-top: 4%">
        <!--<div class="b-left"></div>-->
        <div class="b-box-img" v-for="(item) in dzfpImgList">
          <div class="img_back div_click"  @click="showPopup('FDFP',item.url)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div>
        <div style="margin-top: 5%">
          <span class="p_lin" >附件1 &nbsp;</span>
          <span style="color: #3485fa"></span>
        </div>
        <div style="margin-left: 5%;margin-top: 0.5rem;color: #3485fa">
          处方、检查、化验结果报告单；国谈药品备案申请表；高值药品审核表
        </div>
      </div>
      <div class="dzfpImgDiv" style="margin-top: 4%">
        <!--<div class="b-left"></div>-->
        <div class="b-box-img" v-for="(item) in fjImgList1">
          <div class="img_back div_click"  @click="showPopup('FDFP',item.url)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div>
        <div style="margin-top: 5%">
          <span class="p_lin" >附件2 &nbsp;</span>
          <span style="color: #3485fa"></span>
        </div>
        <div style="margin-left: 5%;margin-top: 0.5rem;color: #3485fa">
          治疗明细清单
        </div>
      </div>
      <div class="dzfpImgDiv" style="margin-top: 4%">
        <!--<div class="b-left"></div>-->
        <div class="b-box-img" v-for="(item) in fjImgList2">
          <div class="img_back div_click" @click="showPopup('FDFP',item.url)">
            <img class="img_all sfz" :src="item.url" >
            <div class="b-box-z">{{item.title}}</div>
          </div>
        </div>
      </div>
      <div class="clear"></div>
      <div class="lastDiv">
        <button :class="cannotSubmit===true ? 'submit_btn submit_btn_gray' : 'submit_btn'" @click="allSubmit" :disabled="cannotSubmit">返&nbsp;&nbsp;&nbsp;&nbsp;回</button>
      </div>
    </div>
    <mt-actionsheet
      :actions="downActions"
      v-model="sheetVisible">
    </mt-actionsheet>
    <mt-popup
      v-model="popupFP1"
      popup-transition="popup-fade">
      <div class="popupDiv">
        <img style="width: 500px;height:400px;" src="../../../static/img/wsbx_zzfp.png">
      </div>
    </mt-popup>
    <mt-popup
      v-model="popupFP2"
      popup-transition="popup-fade">
      <div class="popupDiv">
        <img style="width: 500px;height:400px;" src="../../../static/img/wsbx_czfp.png">
      </div>
    </mt-popup>
    <mt-popup
      v-model="popupFP3"
      popup-transition="popup-fade">
      <div class="popupDiv">
        <img class="fdFp3" style="width: 500px;height:400px;" :src="fdFp3url">
      </div>
    </mt-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import header from '@/components/header/header.vue'
import wx from 'weixin-js-sdk'
import {Indicator, MessageBox, Actionsheet} from 'mint-ui'
Vue.component(Actionsheet.name, Actionsheet)
export default {
  components: {
    'app-header': header
  },
  data () {
    return {
      header_show: true, // true和false控制头部显示或者不显示
      tempImgUrl: require('../../assets/images/wsbx/ywbl_146.png'),
      sfzImgList: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '正面', type: 'temp'},
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '反面', type: 'temp'}
      ],
      yhkImgList: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      dzfpImgList: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      fjImgList1: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      fjImgList2: [
        {url: require('../../assets/images/wsbx/ywbl_146.png'), title: '上传', type: 'temp'}
      ],
      downActions: [
        {name: '查看大图', method: this.previewImg}
      ],
      sheetVisible: false,
      selectedImg: {},
      cannotSubmit: false,
      alreadySubmit: false,
      popupFP1: false,
      popupFP2: false,
      popupFP3: false,
      fdFp3url: ''
    }
  },
  mounted () {
    this.$refs.yh_hm.value = localStorage.getItem('aac003')
    this.$refs.aac002.value = localStorage.getItem('aac002')
    // 获取银行卡号
    this.getBankNo()
    this.wxConfig()
  },
  methods: {
    // 微信js初始化
    wxConfig () {
      Indicator.open({
        text: '微信接口初始化...',
        spinnerType: 'fading-circle'
      })
      var params = new URLSearchParams()
      var signUrl = /(Android)/i.test(navigator.userAgent) ? location.href.split('#')[0] : window.entryUrl
      params.append('url', signUrl)
      this.$http.post('/api/weJSsdkSign', params).then((res) => {
        Indicator.close()
        wx.config({
          debug: false, // 开启调试模式,
          appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ['config', 'hideMenuItems', 'chooseImage', 'uploadImage', 'getLocalImgData', 'updateTimelineShareData',
            'downloadImage'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        })
        wx.ready(function () {
          // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮
          wx.hideMenuItems({
            menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline', 'menuItem:share:qq', 'menuItem:share:weiboApp', 'menuItem:favorite', 'menuItem:share:facebook', 'menuItem:share:QZone',
              'menuItem:editTag', 'menuItem:delete', 'menuItem:copyUrl', 'menuItem:originPage', 'menuItem:readMode', 'menuItem:openWithQQBrowser', 'menuItem:openWithSafari', 'menuItem:share:email', 'menuItem:share:brand']
          })
        })
        wx.error(function (res) {
          MessageBox.alert('微信环境配置失败!')
        })
      })
    },
    // 提交确认
    confirmSubmit () {

    },
    // 提交
    allSubmit () {
      this.$router.go(-1)
    },
    // 继续办理
    newBusiness () {
      let that = this
      if (this.alreadySubmit === false) {
        MessageBox.confirm('', {
          message: '您还有未提交的数据!确定刷新页面吗?',
          title: '警告'
        }).then(action => {
          if (action === 'confirm') {
            that.clearData()
          }
        }).catch(err => {
          if (err === 'cancel') {
            console.log('cancel')
          }
        })
      } else {
        that.clearData()
      }
    },
    showPopup (type, surl) {
      if (type === 'ZZFP') {
        this.popupFP1 = true
        this.popupFP2 = false
        this.popupFP3 = false
      } else if (type === 'CZFP') {
        this.popupFP2 = true
        this.popupFP1 = false
        this.popupFP3 = false
      } else if (type === 'FDFP') {
        this.popupFP3 = true
        this.fdFp3url = surl
        this.popupFP1 = false
        this.popupFP2 = false
      }
    },
    clearData () {
      this.sfzImgList = [
        {url: this.tempImgUrl, title: '正面', type: 'temp'},
        {url: this.tempImgUrl, title: '反面', type: 'temp'}
      ]
      this.yhkImgList = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.dzfpImgList = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.fjImgList1 = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.fjImgList2 = [
        {url: this.tempImgUrl, title: '上传', type: 'temp'}
      ]
      this.sheetVisible = false
      this.selectedImg = {}
      this.cannotSubmit = false
      this.alreadySubmit = false
      this.popupFP1 = false
      this.popupFP2 = false
    },
    dealSFZH (aac002) {
      if (aac002.length === 18) {
        return aac002.substr(0, 3) + '***********' + aac002.substr(14)
      } else {
        return aac002.substr(0, 3) + '********' + aac002.substr(11)
      }
    },
    getBankNo () {
      var params = new URLSearchParams()
      var ykc190 = this.$route.params.ykc190
      params.append('jybh', 'kxc_declarebx_cx001')
      params.append('ykc190', ykc190)
      params.append('aac001', localStorage.getItem('aac001'))
      params.append('aac002', localStorage.getItem('aac002'))
      params.append('access_token', localStorage.getItem('access_token'))
      this.$http.post('/api/kxcwx/queryData', params).then(res => {
        if (res.data.code === '1') {
          var output = res.data.output
          if (output.length > 0) {
            this.$refs.yh_kh.value = output[0].aae010
            this.$refs.yh_mc.value = output[0].aae008
            this.$refs.aae005.value = output[0].aae005

            // eslint-disable-next-line no-unused-vars
            let imglist = output[0].imglist
            // eslint-disable-next-line no-unused-vars
            let imglist1 = output[0].imglist1
            // eslint-disable-next-line no-unused-vars
            let imglist2 = output[0].imglist2
            // eslint-disable-next-line no-unused-vars
            let imglist3 = output[0].imglist3
            this.sfzImgList = imglist
            this.dzfpImgList = imglist1
            this.fjImgList1 = imglist2
            this.fjImgList2 = imglist3
            // 正式环境地址 /kxcapp/front/services/kxcwx/downloadFilePic?fileid=
            // 测试环境地址 /api/kxcwx/downloadFilePic?fileid=
            for (let i = 0; i < imglist.length; i++) {
              this.sfzImgList[i].url = '/kxcapp/front/services/kxcwx/downloadFilePic?fileid=' + imglist[i].fileid
            }
            for (let i = 0; i < imglist1.length; i++) {
              this.dzfpImgList[i].url = '/kxcapp/front/services/kxcwx/downloadFilePic?fileid=' + imglist1[i].fileid
            }
            for (let i = 0; i < imglist2.length; i++) {
              this.fjImgList1[i].url = '/kxcapp/front/services/kxcwx/downloadFilePic?fileid=' + imglist2[i].fileid
            }
            for (let i = 0; i < imglist3.length; i++) {
              this.fjImgList2[i].url = '/kxcapp/front/services/kxcwx/downloadFilePic?fileid=' + imglist3[i].fileid
            }
          }
        } else {
          /* MessageBox.alert('查询银行卡号失败!' + res.data.message) */
        }
      })
    }

  },
  beforeRouteEnter (to, from, next) {
    /* var u = navigator.userAgent
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
    // XXX: 修复iOS版微信HTML5 History兼容性问题
    if (isiOS && to.path !== location.pathname) {
      // 此处不可使用location.replace
      location.assign(to.fullPath)
    } else {
      next()
    } */
    next()
  },
  beforeRouteLeave (to, form, next) {
    /* alert('bbbbbbllleave')
      MessageBox.confirm('Are you sure?').then(action => {
       alert('曲儿')
       next()
     }, action => {
       alert('区县')
     }) */
    next()
  }

}
</script>
<style scoped>
   @import '../../../static/css/wsbx_sb.css';
  .dzfpImgDiv{
    width: 88%;
    margin-left: 4%;
    padding-left: 4%;
    padding-top: 2rem;
    padding-bottom: 2rem;
    /*height: 15rem;*/
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    /*justify-content:center;*/
    border: 1px dashed #3485FA;
    border-radius: 0.8rem;
  }
   .linkBtn{
     text-align: center;
     background-color: #3485FA;
     margin: auto;
     border-radius: 0.3rem;
     color: #ffffff;
     font-size: 0.9rem;
     padding: 0.2rem;
     margin-right: 0.5rem;
     margin-top: 0.5rem;
   }
   .popupDiv{
     height: 50vh;
     width: 90vw;
     color: #3485fa;
     overflow: auto;
   }
</style>



// WEBPACK FOOTER //
// src/project/ywbl/wsbx_sbcx_mz.vue